import styled, { css } from 'styled-components'

import OpensansBold from '../assets/fonts/OpenSans-Bold.ttf'
import OpensansExtrabold from '../assets/fonts/OpenSans-ExtraBold.ttf'
import OpensansLight from '../assets/fonts/OpenSans-Light.ttf'
import OpensansRegular from '../assets/fonts/OpenSans-Regular.ttf'
import RobotoBold from '../assets/fonts/Roboto-Bold.ttf'
import RobotoExtrabold from '../assets/fonts/Roboto-Black.ttf'
import RobotoLight from '../assets/fonts/Roboto-Light.ttf'
import RobotoRegular from '../assets/fonts/Roboto-Regular.ttf'

export const containerstyles = css`
  background-color: ${(props) => props.theme.palette.background.main};
  display: flex;
  flex-direction: column;
  height: 100vh;

  .container {
    max-width: 93%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;

    @media (min-width: 1200px) {
      overflow: hidden;
    }
  }
`

export const contentstyles = css`
  padding: 0.5rem;

  @media (min-width: 900px) {
    padding: 1rem 2rem;
  }

  @media (min-width: 1800px) {
    padding: 2rem 4rem;
  }

  .text,
  .sidebox,
  .bottom,
  .objective,
  .imageandtext,
  .middle {
    @media (max-width: 900px) {
      display: block !important;
    }
  }

  .indented {
    text-indent: 1rem;

    @media(min-width: 900px) {
      text-indent: 2rem;
    }
  }

  .title {
    color: ${(props) => props.theme.palette.primary.main};
    margin-bottom: 1rem;

    @media (min-width: 900px) and (min-height: 900px) {
      margin-bottom: 2rem;
    }

    h3 {
      margin: 0;
      font-family: Roboto;
      font-weight: 900;
    }
  }
`

export const animationstyles = css`
  @keyframes fadeup {
    from {
      transform: translateY(20px);
      opacity: 0;
    }

    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide {
    from {
      transform: translateX(-80px);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const fontstyles = css`
  @font-face {
    font-family: OpenSans;
    src: url(${OpensansBold});
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: OpenSans;
    src: url(${OpensansExtrabold});
    font-weight: bolder;
    font-style: normal;
  }

  @font-face {
    font-family: OpenSans;
    src: url(${OpensansLight});
    font-weight: lighter;
    font-style: normal;
  }

  @font-face {
    font-family: OpenSans;
    src: url(${OpensansRegular});
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: Roboto;
    src: url(${RobotoBold});
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: Roboto;
    src: url(${RobotoExtrabold});
    font-weight: bolder;
    font-style: normal;
  }

  @font-face {
    font-family: Roboto;
    src: url(${RobotoLight});
    font-weight: lighter;
    font-style: normal;
  }

  @font-face {
    font-family: Roboto;
    src: url(${RobotoRegular});
    font-weight: normal;
    font-style: normal;
  }
`
export const conteudointerno = css`  
  background-color: ${(props) => props.theme.palette.primary.light};
  

  .container {
    background-color: ${(props) => props.theme.palette.background.main};
    box-sizing: border-box;
    margin: .5rem 1rem;
    width: calc(100vw - 2rem);
    height: calc(100vh - 1rem);    
    border-radius: 1.5rem;
    box-shadow: 0 7px 14px rgba(0, 0, 0, 0.15), 0 5px 5px rgba(0, 0, 0, 0.15);

    @media(min-width: 900px) {      
      margin: 1rem auto;
      width: calc(100vw - 4rem);
      height: calc(100vh - 2rem);
    }
    
    @media(min-width: 1920px) {
      margin: auto;
      margin-top: 1rem;
      margin-bottom: 1rem;      
    }
  }
`

export const LetterButton = styled.button`
  background-color: ${(props) => props.theme.palette.primary.main};
  color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);  
  padding: 1rem;
  border-radius: 1rem;
  border: none;

  &:focus {    
    outline: none;
  }

  p {
    font-family: Roboto;
    font-weight: 900;
  }

  ${(props) =>
    props.selected
        ? `
        background-color: ${props.theme.palette.primary.dark};
        box-shadow: 0 7px 14px rgba(0, 0, 0, 0.15), 0 5px 5px rgba(0, 0, 0, 0.15);           
    ` : ''};

  ${(props) => props.last ? '':`
    margin-bottom: .5rem;

    @media(min-width: 900px) {
      margin-bottom: 0;
      margin-right: 1rem;
    }
  `};
`

export const Selector = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.palette.background.main};
  color: ${(props) => props.theme.palette.primary.dark};
  width: 2.25rem;
  height: 2.25rem;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  margin: 7.5px;
  padding: 0.5rem;
  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.palette.primary.dark};

  p {    
    font-family: Roboto;
    font-weight: 900;
  }

  @media (min-width: 900px) {
    margin: 10px;
  }

  :focus {
    outline: none;
  }

  ${(props) =>
    props.selected
      ? `
    background-color: ${props.theme.palette.primary.dark};
    color: ${props.theme.palette.background.main};
    box-shadow: 0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22);
  `
      : `
    background-color: ${props.theme.palette.background.main};
    color: ${props.theme.palette.primary.dark};
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  `};
`
